import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineXL } from '@sorare/core/src/atoms/typography';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import footballBg from './assets/football.webp';
import mlbBg from './assets/mlb.webp';
import nbaBg from './assets/nba.webp';

const Wrapper = styled(Vertical).attrs({ center: true, gap: 2 })<{
  background: string;
}>`
  background: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center;
  height: calc(
    100vh - var(--current-stack-height) - var(--app-header-height-mobile)
  );
  padding: 0 10% 20% 10%;
  justify-content: flex-end;
  text-align: center;
  color: var(--c-nd-600);
  font: var(--t-20);

  b,
  button {
    font-weight: var(--t-bold);
    color: var(--c-white);
    text-decoration: underline;
  }
`;

const backgrounds = {
  [Sport.FOOTBALL]: footballBg,
  [Sport.BASEBALL]: mlbBg,
  [Sport.NBA]: nbaBg,
};

export const DisabledMarket = () => {
  const { sport } = useSportContext();
  const background = backgrounds[sport];
  const { postOpenCurrentUrlMessage } = useIsMobileApp();

  const link = (content: ReactNode[]) => {
    if (postOpenCurrentUrlMessage) {
      return (
        <ButtonBase onClick={() => postOpenCurrentUrlMessage()}>
          {content}
        </ButtonBase>
      );
    }

    return <b>{content}</b>;
  };

  return (
    <Wrapper background={background}>
      <HeadlineXL as="h2" color="var(--c-white)">
        <FormattedMessage
          defaultMessage="The Marketplace is not{br}available in the app"
          values={{
            br: <br />,
          }}
        />
      </HeadlineXL>
      <span>
        <FormattedMessage
          defaultMessage="To buy officially licensed cards please{br}visit <b>sorare.com</b>"
          values={{ b: link, br: <br /> }}
        />
      </span>
    </Wrapper>
  );
};
